//
export default function layoutResizing() {
    // Check if the user is accessing the page on a mobile device
    let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // For use with waitForFinalEvent
    let uniqueId = 0;

    // Waits for final resize event and fires once
    let waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
            if (!uniqueId) {
                uniqueId = 0;
            }
            if (timers[uniqueId]) {
                clearTimeout (timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
            uniqueId++;
        };
    })();

    $(window).resize(function () {
        waitForFinalEvent(function(){
            $(document).ready(function() {
                if (!isMobile) {
                    location.reload();
                }
            });
        }, 500, uniqueId);
    });

}